export default {
  Highcharts: 'Chart',
  Highstock: 'StockChart',
  Highmaps: 'Map',
  HighchartsRenderer: 'Renderer'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-highcharts/src/constructors.js
// module id = /TML
// module chunks = 0